// FIXME: This is only currently used for the User Profile row;
// if we ever support additional properties on this row then we

import { convertGlideDateTime } from "../../../date-time/glide-date-time";
import type { Database } from "../../Database";
import type { JSONObject } from "../../Support";
import { assert, isUndefinedish } from "../../Support";
import type { ArrayRefObject } from "../data";
import { ArrayRefValueProducer, Data as DataData, isKeyRefObject, isRefObject } from "../data";
import type { AppEnvironment, AppOther, Value } from "../types";
import { Data } from "../types";

function makeValueData(
    db: Database,
    name: string,
    value: unknown,
    arrayRefs: [string, ArrayRefObject][],
    f: (v: Value) => void
): void {
    let v = db.convertDocumentProperty(value);

    assert(!isUndefinedish(v));
    if (Array.isArray(v)) {
        v = v.map(i => new DataData(i));
    } else if (isRefObject(v) && !isKeyRefObject(v)) {
        arrayRefs.push([name, v]);
        return;
    }
    f(v as Value);
}

// need to pass in the schema.
export function convertJSONObjectToRowData(db: Database, obj: JSONObject): Data {
    const rowData = new Data<AppOther, AppEnvironment>({});
    const arrayRefs: [string, ArrayRefObject][] = [];

    for (const key of Object.keys(obj)) {
        const value = convertGlideDateTime(obj[key]);
        if (value === undefined) continue;

        makeValueData(db, key, value, arrayRefs, v => {
            rowData.addPropertyWithoutUpdate(key, new DataData(v));
        });
    }

    for (const [name, arrayRef] of arrayRefs) {
        const arrayRefValue = new ArrayRefValueProducer(arrayRef.$arrayItems, rowData);
        rowData.addPropertyWithoutUpdate(name, arrayRefValue);
    }

    return rowData;
}
